export const DEFAULT_CLEANING_DURATION_MINUTES = 30;
export const DEFAULT_CHARGING_DURATION_MINUTES = 15;

// Slower than dnd-kit's 200ms default so the check/uncheck reorder reads as a deliberate move.
export const CLEANING_AREA_LIST_SORTABLE_TRANSITION = { duration: 350, easing: 'ease' };
